import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'minutesToHoursFormatter' })
export class MinutesToHoursFormatterPipe implements PipeTransform {

    transform(value: number): string {
        if (!value) {
            return '-'
        }
        const hours = Math.floor(value / 60);
        const minutes = value % 60;
        const minutesString = minutes >= 10 ? `${minutes}m` : `0${minutes}m`
        if (hours > 0) {
            return `${hours}h ${minutesString}`;
        }
        return minutesString;
    }
}
